import { render, staticRenderFns } from "./MyChangeKefu.vue?vue&type=template&id=b398efae&scoped=true"
import script from "./MyChangeKefu.vue?vue&type=script&lang=js"
export * from "./MyChangeKefu.vue?vue&type=script&lang=js"
import style0 from "./MyChangeKefu.vue?vue&type=style&index=0&id=b398efae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b398efae",
  null
  
)

export default component.exports